"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _spacing = require("@amzn/meridian-tokens/base/spacing");

var _elevation = require("@amzn/meridian-tokens/base/elevation");

var _button = _interopRequireDefault(require("../button"));

var _visuallyHidden = _interopRequireDefault(require("./../_styles/visually-hidden"));

var styles = (0, _emotion.css)({
  position: "fixed",
  top: _spacing.spacingMedium,
  left: _spacing.spacingMedium,
  zIndex: _elevation.elevationPopover,
  "&:not(:focus)": _visuallyHidden["default"]
});
/**
 * Use this component to add a "skip navigation" accessibility link to your app.
 * A skip navigation link allows keyboard users to quickly skip over long lists
 * of navigation items (links, buttons, etc.) to the main page content. These
 * links should be placed before any other focuseable elements on the page so
 * that they come first in the tab order. Read more about skip navigation links
 * here: https://webaim.org/techniques/skipnav/.
 *
 * NOTE: The AppLayout component comes pre-packaged with a SkipNavigationLink.
 * We recommend using that component to handle your application layout if
 * possible.
 */

var SkipNavigationLink = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var targetId = _ref.targetId,
      children = _ref.children;
  var onClick = (0, _react.useCallback)(function () {
    var targetElement = document.querySelector("#".concat(targetId));

    if (targetElement) {
      targetElement.focus();
    }
  }, [targetId]);
  return /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "secondary",
    onClick: onClick,
    className: styles
  }, children);
});

SkipNavigationLink.displayName = "SkipNavigationLink";
SkipNavigationLink.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The link title.
   */
  children: _propTypes["default"].string.isRequired,

  /**
   * The id of the element to skip to when the link is activated.
   */
  targetId: _propTypes["default"].string
} : {};
var _default = SkipNavigationLink;
exports["default"] = _default;